import {CreateProfileParams, GeneralProfileFactory} from "../general-profile/general-profile.factory";
import {MountingProfile} from "./mounting-profile";
import {ColorConverter} from "../../../../../core/util/color-converter";

export type CreateMountingProfileParams = {
    // mounting profile specific constructor parameters
} & CreateProfileParams;

export class MountingProfileFactory extends GeneralProfileFactory {

    static override createProfile(
        params: CreateMountingProfileParams = {
            productCode: "P-22284",
            materialType: 'Powder Coated',
            color: '#82898F'
        }
    ): MountingProfile {
        return {
            id: 6,
            productCode: params.productCode,
            materialType: params.materialType as 'Powder Coated' | 'Anodized',
            color: ColorConverter.convert(params.color),
            object3dUrl: params.productCode.toLowerCase()+'.obj' //hox this wont work on any objects that arent seeded since file upload system obfuscates file name
        };
    }

    /**
     * Create a new `MountingProfile` instance from an existing `MountingProfile` instance.
     * @param data
     */
    static copy(data: MountingProfile): MountingProfile {

        return {
            id: data.id ||6,
            productCode: data.productCode,
            materialType: data.materialType,
            color: data.color,
            object3dUrl: data.object3dUrl
        };

    }

}